// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1wBjD","col":"styles_col__vPkTE"};